<template>
  <div class="hello">
    <div class="page_link_view">
      <div id="about">
        <p>
          東京カートグラフィックの「世界がわかるトランプ」「日本がわかるトランプ」のオリジナルゲームが楽しめるWebアプリです。
          遊びたいトランプを選んでゲームを始めましょう！
        </p>
      </div>

      <router-link to="/world" class="r_link_btn activ_btn">
        <img :src="world_menu" alt="world_menu">
      </router-link>
      <router-link to="/japan" class="r_link_btn activ_btn">
        <img :src="japan_menu" alt="japan_menu">
      </router-link>
    </div>
  </div>
</template>

<script>
/**
 * メインメニュー（トップページ）
 * 
 * @vue-data {Object} [world_menu] 世界編メニューイメージ
 * @vue-data {Object} [japan_menu] 日本編メニューイメージ
 */
export default {
  name: "MainMenuView",

  data () {
    return {
      world_menu: require("../assets/world_menu.png"),
      japan_menu: require("../assets/japan_menu.png")
    }
  },

  mounted () {
    this.$store.dispatch("setCurrentGame", { gameName: "Home" }) // 保存
  }
}
</script>

<style lang="sass" src='../assets/common_style.sass'></style>
<style lang="sass" scoped>

#about
  background-color: rgba(255,255,255,0.7)
  padding: 24px
  border-radius: 10px
  max-width: 560px
  margin: 10px
  user-select: none
  p
    margin: 0
    padding: 0
    font-size: 15px
    font-weight: 600

</style>
